import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueScrollTo from 'vue-scrollto'
import VueMeta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import './plugins/vue-gtag.js'

const wpAPI = '' // process.env.VUE_APP_WP_API
Vue.config.WP = {
  baseUrl: wpAPI,
  API: wpAPI + '/wp-json/wp/v2', // WP REST API
  ACF: wpAPI + '/wp-json/acf/v3' // WP ACF REST API
}

Vue.use(VueMeta)
Vue.use(VueScrollTo, { duration: 800 })
Vue.use(VueLazyload, { observer: false, preLoad: 2 })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
